import { upperCase } from "lodash";

export const AnnouncementModel = {
  id: null,
  title: "",
  html: "",
  icon: "",
  link: "",
  creationDate: "",
  expirationDate: "",
  lastUpdate: "",
  author: "",
  agency: "",
  roadway: "",
  state: "",
  state2: null,
  priority: "MEDIUM",
  eventIds: [],
  weatherDotGovId: null,
  highPriorityPageOrder: 0,
  highPriorityPage: false,
  newsItem: false,
  siteNews: false,
  construction: false,
  transit: false,
  weather: false,
  trucker: false,
};

export const getStates = async (setStates) => {
  var endpoint = "/admin/announcements/states.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setStates(res.data);
      console.log("response" + JSON.stringify(res));
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const getAgencies = async (setAgencies) => {
  var endpoint = "/admin/announcements/agencies.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setAgencies(res.data);
      console.log("response" + JSON.stringify(res));
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const getRoadways = async (setRoadways) => {
  var endpoint = "/admin/announcements/roadways.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setRoadways(res.data);
      console.log("response" + JSON.stringify(res));
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const getPriorities = async (setPriorities) => {
  var endpoint = "/admin/announcements/priorities.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setPriorities(res.data);
      console.log("response" + JSON.stringify(res));
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const getEvents = async (id, setEvents) => {
  var endpoint = "/admin/announcements/events.json"
  var tempDataEvents={
    "success": true,
    "data": [
        {
            "id": 144115188700577500,
            "type": "RoadWork",
            "externalId": "IL-GAI-ROADWORK.2025.4.2.8.6404172",
            "location": "Partial closure NB and SB IL-127 from Oakdale Blacktop Rd to Pierce Rd, Nashville, Washington, IL",
            "description": "Expect lane restrictions for roadway improvement. Vehicle width restricted to 12' 6\".",
            "operator": "IDOT GAI",
            "active": true
        },
        {
            "id": 144115188700633549,
            "type": "RoadWork",
            "externalId": "IN-CARS-GTIS-66ea768e58c3126b:750c0e27:1965f2130e1:-375",
            "location": "Partial closure EB I-94 from US-421 to near US-421, Unincorporated Laporte County (Michigan City), IN",
            "description": "roadwork",
            "operator": "Gateway System",
            "active": false
        },
        {
            "id": 144115188700633550,
            "type": "RoadWork",
            "externalId": "IL-TESTTIMS-GTIS-66ea768e58c3126b:750c0e27:1965f2130e1:-374",
            "location": "Partial closure SB I-39/90 (Jane Addams Memorial Tollway) at South Beloit Plaza, Unincorporated Winnebago County (Roscoe), IL",
            "description": "ETC",
            "operator": "Gateway System",
            "active": false
        },
        {
            "id": 144115188700526438,
            "type": "RoadWork",
            "externalId": "IN-ITR-GTIS-898ea35c2711b475:78d6ed22:195c709bab7:-7b8c",
            "location": "All lanes open WB I-80/90 (Indiana East-West Toll Rd) from County Road 425 E to near County Road 425 E, Unincorporated Laporte County (Rolling Prairie), IN",
            "description": "Bridge Work- - -24 Hour Continuous Shoulder Closure",
            "operator": "Gateway System",
            "active": false
        },
        {
            "id": 144115188700605774,
            "type": "RoadWork",
            "externalId": "IL-TESTTIMS-GTIS-66ea768e58c3126b:750c0e27:196405e599f:-1f3d",
            "location": "Full closure EB I-90 (Jane Addams Memorial Tollway) at Roselle Rd, Schaumburg, Cook, IL",
            "description": "ETC",
            "operator": "Gateway System",
            "active": false
        },
        {
            "id": 144115188700557035,
            "type": "RoadWork",
            "externalId": "IL-GAI-8-3477E1F6-F663-4E21-9B8D-F49E2E86D9FD-16b8e671781dd2f8:-3127e86b:195f69b6279:-7ebf",
            "location": "Partial closure NB and SB IL-127 from Oakdale Blacktop Rd to Pierce Rd, Nashville, Washington, IL",
            "description": "Expect lane restrictions for roadway improvement. Vehicle width restricted to 12' 6\".",
            "operator": "IDOT GAI",
            "active": true
        },
        {
            "id": 144115188700633551,
            "type": "RoadWork",
            "externalId": "IL-TESTTIMS-GTIS-66ea768e58c3126b:750c0e27:1965f2130e1:-373",
            "location": "All lanes open Ramp from NB I-57 to NB I-294, Posen, Cook, IL",
            "description": "Conduit Work",
            "operator": "Gateway System",
            "active": false
        },
        {
            "id": 144115188700557037,
            "type": "RoadWork",
            "externalId": "IL-GAI-5-5F0CA4F6-794F-488B-B0F6-7C87A6E6BB75-16b8e671781dd2f8:-3127e86b:195f69b6279:-7eb3",
            "location": "Partial closure SB I-57 from County Road 2700 to County Road 2500, Unincorporated Champaign County (Rantoul), IL",
            "description": "Expect lane restrictions for roadway improvement. Vehicle width restricted to 12'.",
            "operator": "IDOT GAI",
            "active": false
        },
        {
            "id": 144115188700420967,
            "type": "RoadWork",
            "externalId": "IL-GAI-ROADWORK.2025.2.24.12.6369461",
            "location": "Partial closure EB and WB Main St from Springer St to Mattison St, East Galesburg, Knox, IL",
            "description": "The movement of vehicles are restricted. Vehicle length restricted to 55', width to 8' 6\".",
            "operator": "IDOT GAI",
            "active": true
        },
        {
            "id": 144115188700420968,
            "type": "RoadWork",
            "externalId": "IL-GAI-4-35B5075F-4AB6-471B-BA08-4B0459AC19E4-ce4086593c858acf:1880f8e5:19539346a80:-7f55",
            "location": "Partial closure EB and WB Main St from Springer St to Mattison St, East Galesburg, Knox, IL",
            "description": "The movement of vehicles are restricted. Vehicle length restricted to 55', width to 8' 6\".",
            "operator": "IDOT GAI",
            "active": true
        },
        {
            "id": 144115188700420971,
            "type": "RoadWork",
            "externalId": "IL-GAI-ROADWORK.2025.2.24.12.6369463",
            "location": "Partial closure NB and SB IL-160 from 38.7395000°N, -89.6710900°E to 38.7395500°N, -89.6719400°E, Unincorporated Madison County (Highland), IL",
            "description": "The movement of vehicles is restricted. Vehicle length restricted to 75'.",
            "operator": "IDOT GAI",
            "active": true
        },
        {
            "id": 144115188700420972,
            "type": "RoadWork",
            "externalId": "IL-GAI-8-AA6DA23C-6850-4390-8962-87A67599ECC5-ce4086593c858acf:1880f8e5:19539346a80:-7f50",
            "location": "Partial closure NB and SB IL-160 from 38.7395000°N, -89.6710900°E to 38.7395500°N, -89.6719400°E, Unincorporated Madison County (Highland), IL",
            "description": "The movement of vehicles is restricted. Vehicle length restricted to 75'.",
            "operator": "IDOT GAI",
            "active": true
        },
        {
            "id": 144115188700420975,
            "type": "RoadWork",
            "externalId": "IL-GAI-ROADWORK.2025.2.24.12.6369465",
            "location": "partial closure NB IL-160 from Veterans Honor Pkwy to Poplar St, Unincorporated Madison County (Highland), IL and partial closure WB US-40 from 38.7504900°N, -89.6717400°E to 38.7498500°N, -89.6717600°E",
            "description": "The movement of vehicles is restricted. Vehicle length restricted to 75'.",
            "operator": "IDOT GAI",
            "active": true
        },
        {
            "id": 144115188700420976,
            "type": "RoadWork",
            "externalId": "IL-GAI-8-8696129C-A864-4E39-888A-2A402BACCC31-ce4086593c858acf:1880f8e5:19539346a80:-7f4e",
            "location": "partial closure NB IL-160 from Veterans Honor Pkwy to Poplar St, Unincorporated Madison County (Highland), IL and partial closure WB US-40 from 38.7504900°N, -89.6717400°E to 38.7498500°N, -89.6717600°E",
            "description": "The movement of vehicles is restricted. Vehicle length restricted to 75'.",
            "operator": "IDOT GAI",
            "active": true
        }
      ] }
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setEvents(res.data);
      console.log("response" + JSON.stringify(res));
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
  // setEvents(tempDataEvents.data)
};

export const getAnnouncements = async (
  state,
  agency,
  priority,
  roadway,
  type,
  includeExpired,
  setAnnouncements
) => {
  var endpoint = "/admin/announcements/all.json?";
  if (state !== "all") endpoint = endpoint + "&state=" + state;
  if (agency !== "all") endpoint = endpoint + "&agency=" + agency;
  if (priority !== "all")
    endpoint = endpoint + "&priority=" + upperCase(priority);
  if (roadway !== "all") endpoint = endpoint + "&roadway=" + roadway;
  if (type !== "all") endpoint = endpoint + "&type=" + type;
  if (!includeExpired) endpoint = endpoint + "&includeExpired=" + includeExpired;
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      // console.log("response" + JSON.stringify(res));
      // setAnnouncements(res.data.sort((a,b)=>(a.highPriorityPageOrder,undefined,{numeric:true}).toString().localeCompare(b.highPriorityPageOrder,undefined, {numeric: true})));
      setAnnouncements(res.data)
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const getAnnouncementLogs = async (
  announcementId,
  setAnnouncementLogs
) => {
  var endpoint = "/admin/announcements/" + announcementId + "/logs.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setAnnouncementLogs(res.data);
      // console.log("response " + endpoint + " :" + JSON.stringify(res));
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const getAnnouncement = async (announcementId, setAnnouncement) => {
  var endpoint =
    "/admin/announcements/" + announcementId + "/announcement.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setAnnouncement(res.data);
      // console.log("response " + endpoint + " :" + JSON.stringify(res));
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const createAnnouncement = async (announcement) => {
  var endpoint = "/admin/announcements/announcement.json";
  // announcement.id=Date.now();
  announcement.creationDate=new Date().toISOString();
  announcement.lastUpdate=new Date().toISOString();
  // console.log(JSON.stringify(announcement));
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(announcement),
    })
      .then((res) => {
        // console.log("response " + endpoint + " :" + JSON.stringify(res));
        alert("New Announcement Created");
      })
      .then((data) => {
        // console.log("response " + endpoint + " :" + JSON.stringify(data));
      });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const saveAnnouncement = async (announcement) => {
  var endpoint =
    "/admin/announcements/" + announcement.id + "/announcement.json";
  // console.log(JSON.stringify(announcement));
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      // body: JSON.stringify({title:announcement.title})
      body: JSON.stringify(announcement),
    })
      .then((res) => {
        // console.log("response " + endpoint + " :" + JSON.stringify(res));
        alert("Announcement Updated");
      })
      .then((data) => {
        // console.log("response " + endpoint + " :" + JSON.stringify(data));
      });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const deleteAnnouncement = async (announcement) => {
  var endpoint =
    "/admin/announcements/" + announcement.id + "/announcement.json";
  // console.log(JSON.stringify(announcement));
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "DELETE",
    }).then((res) => {
      // console.log("response " + endpoint + " :" + JSON.stringify(res));
      // if(res.success){
      // console.log("Announcement deleted successfully");
      alert("Announcement Deleted");
    });
    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};
